/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const ThankYouRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.THANK_YOU.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/summary/ok/ok.module').then(m => m.OkPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.THANK_YOU.EXISTING_CONTRACT_ERROR.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/summary/existing-contract-error/existing-contract-error.module').then(
        m => m.ExistingContractErrorPageModule
      ),
    canActivate: [NavigationGuard],
  },
];
